import React, { useState, useEffect, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { searchUrl, apiUrl, myHeaders_Auth_With_Cache_Control } from 'Api/Api';
import axios from 'axios';
import { feature_names } from 'utils/Routes';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import Table from 'react-bootstrap/Table';
import TableHeader from 'components/Table/TableHeader';
import PechaKuchaUsersTable from 'components/UserTable/PechaKuchaUsersTable';
import UserContext from 'store/UserContext';

import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
const AsyncTypeahead = asyncContainer(Typeahead);

function PechaKuchaUsers(props) {
  const context = UserContext;
  let temp_pagination_from = 0;
  const pagination_limit = 100;
  const [user_table_loading, setUser_table_loading] = useState(true);
  const [add_user_section_loading, setAdd_user_section_loading] =
    useState(false);
  const [users, setUsers] = useState();
  const [pagination_from, setPagination_from] = useState(0);
  const [add_email_text, setAdd_email_text] = useState();
  const [search_text, setSearch_text] = useState();
  const [total_search_results, setTotal_search_results] = useState(0);
  const [message, setMessage] = useState();
  const [error_message, setError_message] = useState();
  const [isFiltering, setIsFiltering] = useState(false);

  const user_table_header_display = {
    Name: '',
    Email: '',
    Profile: '',
    Created: '',
    Status: ''
  };
  let workspace_base_url = '';

  useEffect(() => {
    (async () => {
      await getUsersFromApi();
    })();
  }, []);

  async function getUsersFromApi() {
    let query_filter = 'all';
    try {
      let users_search_response = await axios.get(
        `${searchUrl}sitesearch?sort_by=created_time&sort_order=desc&entity_type=users&q=${encodeURIComponent(
          query_filter
        )}&all_statuses=true&from=${temp_pagination_from}&limit=${pagination_limit}`,
        myHeaders_Auth_With_Cache_Control
      );
      let search_query_results =
        users_search_response.data &&
        users_search_response.data.search_query_results
          ? users_search_response.data.search_query_results
          : [];
      setUsers(search_query_results.map((data) => data.entity_info));

      if (
        users_search_response.data &&
        users_search_response.data.additional_information &&
        'total_search_results' in
          users_search_response.data.additional_information
      ) {
        setTotal_search_results(
          users_search_response.data.additional_information.total_search_results
        );
      }

      setUser_table_loading(false);
      setAdd_user_section_loading(false);
      setAdd_email_text('');
    } catch (err) {
      console.error('Search Error!', err);
      setUser_table_loading(false);
      setAdd_user_section_loading(false);
    }
  }

  async function updateUserAccessLevel(userData, selected_access_level_option) {
    let patch_obj = {
      users: [
        {
          entity_uuid: userData.entity_uuid,
          xref_data: {
            access_level: selected_access_level_option.value
          }
        }
      ]
    };
    setMessage('User Access Level Changed');
    setError_message(null);
    await axios.patch(
      `${apiUrl}organizations/${this.props.org_data.entity_uuid}`,
      patch_obj
    );
  }

  async function paginationHandler(e) {
    let new_pagination_from = 0;
    if (e.direction === 'forward') {
      new_pagination_from = pagination_from + pagination_limit;
      setPagination_from(new_pagination_from);
      temp_pagination_from = new_pagination_from;
      // can't go past the end
      if (new_pagination_from >= users) {
        new_pagination_from = pagination_from;
      }
    } else if (e.direction === 'backward') {
      new_pagination_from = pagination_from - pagination_limit;
      setPagination_from(new_pagination_from);
      temp_pagination_from = new_pagination_from;
      // can't go below 0
      if (new_pagination_from < 0) {
        new_pagination_from = 0;
      }
    }
    setUser_table_loading(true);
    await getUsersFromApi();
  }

  async function clearSearch() {
    setUser_table_loading(true);
    ref.current.clear();
    await getUsersFromApi();
  }

  async function resetFilter(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '') {
        setUser_table_loading(true);
        setPagination_from(0);
        temp_pagination_from = 0;
        await getUsersFromApi();
      }
    }
  }

  //TypeAhead stuff
  const ref = useRef();
  const filterBy = () => true;

  async function filteringUsers(query_filter) {
    setIsFiltering(true);
    setUser_table_loading(true);
    let users_search_response = await axios.get(
      `${searchUrl}sitesearch?sort_by=created_time&sort_order=desc&entity_type=users&q=${encodeURIComponent(
        query_filter
      )}&from=${temp_pagination_from}&limit=${pagination_limit}`,
      myHeaders_Auth_With_Cache_Control
    );
    let search_query_results =
      users_search_response.data &&
      users_search_response.data.search_query_results
        ? users_search_response.data.search_query_results
        : [];
    setUsers(search_query_results.map((data) => data.entity_info));
    setTotal_search_results(null);
    setUser_table_loading(false);
    setIsFiltering(false);
  }

  async function selectedFilteredUser(selectedUser) {
    setPagination_from(0);
    temp_pagination_from = 0;
    setUsers(selectedUser);
    setUser_table_loading(false);
  }

  if (add_user_section_loading) {
    return (
      <div className="presenters-info pkListContainer eventCreation">
        <Row>
          <Col lg={12}>
            <br />
            <h1>{feature_names.Workspace} Users</h1>
            <hr />
            <div className="createEventSpinner">
              <ActivityIndicator theme="spinner" />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="presenters-info pkListContainer eventCreation">
      <Row>
        <Col lg={12}>
          <br />
          <h1>PechaKucha Users</h1>
          <hr />
          <br />
          <Row>
            <Col>
              <div className="search-nav border">
                <i className="fa fa-search nav-search"></i>
                <AsyncTypeahead
                  id="UserTypeAhead"
                  labelKey={(user) =>
                    `${user.entity_name} - ${user.friendly_url}`
                  }
                  isLoading={isFiltering}
                  filterBy={filterBy}
                  placeholder="Search/Filter Users"
                  ref={ref}
                  minLength={0}
                  onChange={selectedFilteredUser}
                  onSearch={filteringUsers}
                  options={users}
                  onKeyDown={resetFilter}
                />
              </div>
            </Col>
            <Col>
              <button
                style={{ marginTop: '0px' }}
                className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons"
                onClick={clearSearch}>
                Clear Search and Refresh
              </button>
            </Col>
          </Row>

          {user_table_loading && (
            <div className="createEventSpinner">
              <ActivityIndicator theme="spinner" />
            </div>
          )}
          {!user_table_loading && (
            <React.Fragment>
              {message && (
                <span style={{ color: 'green', paddingTop: '10px' }}>
                  <br />
                  {message}
                </span>
              )}
              {error_message && (
                <span style={{ color: 'red', paddingTop: '10px' }}>
                  <br />
                  {error_message}
                </span>
              )}
              <p className="related-name" style={{ float: 'right' }}>
                {pagination_from > 0 && (
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      paginationHandler({ direction: 'backward' });
                    }}>
                    Previous
                  </span>
                )}
                {pagination_from + pagination_limit < total_search_results &&
                  pagination_from + pagination_limit < 1000 && (
                    <span
                      style={{ marginLeft: '20px', cursor: 'pointer' }}
                      onClick={() => {
                        paginationHandler({ direction: 'forward' });
                      }}>
                      Next
                    </span>
                  )}
              </p>
              <div className="table-boby">
                <Table variant={context.theme} responsive={true}>
                  <tbody>
                    {/* Pending section header*/}
                    <TableHeader
                      headerType="Users"
                      tableHeader={user_table_header_display}
                      listLength={users.length}
                    />
                    {/* Pending section Body*/}

                    {users.map((item, i) => {
                      return (
                        <PechaKuchaUsersTable
                          key={i}
                          userData={item}
                          workspace_base_url={workspace_base_url}
                          OnChangeDropdown={updateUserAccessLevel}
                        />
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </React.Fragment>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default PechaKuchaUsers;
